export const GUIDED_STEPPER_STATUS_PROGRESS = 'progress';
export const GUIDED_STEPPER_STATUS_INCOMPLETE = 'incomplete';
export const GUIDED_STEPPER_STATUS_COMPLETE = 'complete';
